import React, { useEffect, useState } from 'react';
import { onToast, hideToast } from '@battleops/client/src/data/toast';
import Icon from './Icon';
import s from './Metrics.module.css';

const ICON = { success: 'check-circle', warning: 'alert-triangle', info: 'info' };

// Small notices in the corner (client/data/toast): the undo after a counter tap, a goal reached. Gentle — in the app
// only, gone by themselves.
export default function Toasts() {
  const [list, setList] = useState([]);
  useEffect(() => onToast((e) => {
    if (e.type === 'hide') { setList((l) => l.filter((t) => t.id !== e.id)); return; }
    setList((l) => [...l.slice(-3), e.toast]);
    setTimeout(() => hideToast(e.toast.id), e.toast.ms);
  }), []);
  if (!list.length) return null;
  return (
    <div className={s.toasts} role="status" aria-live="polite">
      {list.map((t) => (
        <div key={t.id} className={s.toast} data-tone={t.tone}>
          <Icon name={ICON[t.tone] || 'info'} size={16} color={t.tone === 'success' ? 'var(--c-success)' : t.tone === 'warning' ? 'var(--c-warning)' : 'var(--c-text-tertiary)'} />
          <div style={{ flex: 1, minWidth: 0 }}><b>{t.title}</b>{t.text ? <small>{t.text}</small> : null}</div>
          {t.action ? <button className="btn sm" onClick={() => { t.action.run(); hideToast(t.id); }}>{t.action.label}</button> : null}
          <button className="btn sm ghost icon" onClick={() => hideToast(t.id)} aria-label="Close"><Icon name="x" size={13} /></button>
        </div>
      ))}
    </div>
  );
}
